import { ColumnMeta, RowData } from '@tanstack/react-table';
import { IAnalysisVisitFieldsFragment } from '../../../../utils/apollo/graphqlSchema';

export const recentActivityTableConfig: Record<
  string,
  ColumnMeta<IAnalysisVisitFieldsFragment, RowData>
> = {
  display: {
    style: {
      flexGrow: 1,
      flexBasis: '120px',
      minWidth: '120px',
      maxWidth: '100%',
    },
  },
  createdAt: {
    style: {
      flexBasis: '180px',
      minWidth: '110px',
    },
  },
  queryType: {
    style: {
      flexBasis: '180px',
      minWidth: '110px',
    },
  },
  visitedAt: {
    style: {
      flexBasis: '180px',
      minWidth: '110px',
    },
  },
  creator: {
    style: {
      flexBasis: '180px',
      minWidth: '110px',
    },
  },
};
